// extracted by mini-css-extract-plugin
export var accordionBody = "styles-module--accordionBody--67cfb";
export var accordionBodyInner = "styles-module--accordionBodyInner--453bb";
export var accordionBodyOpen = "styles-module--accordionBodyOpen--64262";
export var accordionBodyWrapper = "styles-module--accordionBodyWrapper--fbbd3";
export var accordionHeader = "styles-module--accordionHeader--6e48f";
export var accordionItem = "styles-module--accordionItem--efc15";
export var accordionTitle = "styles-module--accordionTitle--4609c";
export var chevron = "styles-module--chevron--61350";
export var open = "styles-module--open--85293";